// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","634":"2c796e83","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"a3d3c536d03c83a3dd24","634":"e97beae21f68e2e33251","678":"5364b6690c7f1e32ed69"}[chunkId] + ".js";
};